import { useMutation } from '@tanstack/react-query';
import { useRequestSections } from '../../../api/request';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/Store';
import Notifications from '../../../ui/molecules/toast/Notifications';
import { handleSendMessageStatus } from '../../../utils/helpers/usePostMessage';
import { clearAuditSaved } from '../../../redux/reducer/coreScriptReducer';
import { setShowSubmitDataError } from '../../../redux/reducer/contextIdReducer';
import { AxiosError } from 'axios';
import { useState } from 'react';

const useSaveData = () => {
  const { Save } = useRequestSections();
  const dispatch = useDispatch();

  const contextId = useSelector(
    (state: RootState) => state.contextId.contextId
  );

  const useContextQueryObj = () => {
    return useSelector((state: RootState) => state.contextId.queryObj);
  };
  const queryObj = useContextQueryObj();

  const {
    mutateAsync: postSubmitData,
    isPending: isSubmitDataPending,
    error: submitDataError,
    isSuccess: successfulSubmitData,
    isError: isSubmitDataError,
    data: submitData,
  } = useMutation<
    any,
    AxiosError,
    { parameter: any; AuditSaved: string | number; Followup: boolean }
  >({
    mutationFn: async ({ parameter, AuditSaved, Followup }) => {
      const response = await Save?.saveData(contextId, parameter);
      if (response?.status === 200) {
        handleSendMessageStatus({
          SubmitComplete: true,
          Context: `${queryObj?.context}`,
          ContextId: `${queryObj?.id}`,
          ContextKey: `${queryObj?.key}`,
          Followup: Followup,
          AuditSaved: AuditSaved,
        });
        dispatch(clearAuditSaved());
      }
      return response?.data;
    },
    onError: (err: AxiosError) => {
      dispatch(setShowSubmitDataError(true)); //forbidden dialog sets to false to clear otherwise will not be able to submit again
      Notifications(err?.message, 0);
    },
  });

  return {
    postSubmitData,
    isSubmitDataPending,
    submitDataError,
    isSubmitDataError,
    successfulSubmitData,
    submitData,
  };
};

export default useSaveData;
